import { offers } from '@/services/offers';

export default {
	namespaced: true,

	state: {
		planOptions: [],
		plansLoading: false,
	},

	getters: {
		planOptions: (state) => state.planOptions,
		plansLoading: (state) => state.plansLoading,
	},

	mutations: {
		SET_PLAN_OPTIONS(state, value) { state.planOptions = value; },
		SET_PLANS_LOADING(state, value) { state.plansLoading = value; },
	},

	actions: {
		async fetchPlanOptions({ commit }) {
			commit('SET_PLANS_LOADING', true);
			try {
				const { data } = await offers.getPlans({ limit: 1000 });
				commit('SET_PLAN_OPTIONS', data?.items || []);
			} catch (error) {
				console.warn('[plansModule/fetchPlanOptions]', error);
				commit('SET_PLAN_OPTIONS', []);
				throw error;
			} finally {
				commit('SET_PLANS_LOADING', false);
			}
		},
	},
};
